<template>
  <div v-if="isLoggedIn" class="d-flex align-items-center ms-auto">
    <!-- Notifications Dropdown -->
    <div class="dropdown me-3">
      <a class="nav-link text-white" href="#" id="notificationDropdown" role="button" @click="toggleNotificationDropdown" aria-expanded="false">
        <i class="bi" :class="activeJobsCount > 0 ? 'bi-arrow-repeat pfe-bell-spin' : 'bi-bell-fill'"></i>
        <span v-if="totalBadgeCount > 0" class="badge rounded-pill notification-badge" :class="activeJobsCount > 0 ? 'bg-warning text-dark' : 'bg-danger'">{{ totalBadgeCount }}</span>
      </a>
      <div class="dropdown-menu dropdown-menu-end notification-dropdown-menu" :class="{ 'show': showNotificationDropdown }" aria-labelledby="notificationDropdown">
        <NotificationList v-if="showNotificationDropdown" />
      </div>
    </div>

    <!-- User Dropdown -->
    <div class="dropdown">
      <a class="nav-link dropdown-toggle text-white" href="#" id="navbarDropdown" role="button" @click="toggleUserDropdown" aria-expanded="false">
        <i class="bi bi-person-circle me-1"></i> {{ user.username || user.email }}
      </a>
      <ul class="dropdown-menu dropdown-menu-end" :class="{ 'show': showUserDropdown }" aria-labelledby="navbarDropdown">
        <li><a class="dropdown-item" href="#" @click.prevent="logout">Déconnexion</a></li>
        <!-- Other options can be added here later -->
      </ul>
    </div>
  </div>
</template>

<script>
import { computed, ref, watch } from 'vue';
import { useRouter } from 'vue-router';
import NotificationList from './NotificationList.vue';
import { userStore } from '@/store/userStore';
import { notificationStore } from '@/store/notificationStore';

export default {
  name: 'UserMenu',
  components: {
    NotificationList,
  },
  setup() {
    const router = useRouter();
    const showNotificationDropdown = ref(false);
    const showUserDropdown = ref(false);

    const user = computed(() => userStore.currentUser);
    const isLoggedIn = computed(() => !!userStore.currentUser);
    const unreadNotificationsCount = computed(() => notificationStore.unreadCount);
    const activeJobsCount = computed(() => Object.keys(notificationStore.jobs).length);
    const totalBadgeCount = computed(() => unreadNotificationsCount.value + activeJobsCount.value);

    // Watch for login status changes to explicitly close dropdowns
    watch(isLoggedIn, (loggedIn, wasLoggedIn) => {
      if (loggedIn && !wasLoggedIn) {
        showUserDropdown.value = false;
        showNotificationDropdown.value = false;
      }
    });

    // Auto-open when a job starts
    watch(activeJobsCount, (count, prev) => {
      if (count > 0 && prev === 0) {
        showNotificationDropdown.value = true;
        showUserDropdown.value = false;
      }
    });

    const toggleNotificationDropdown = () => {
      showNotificationDropdown.value = !showNotificationDropdown.value;
      if (showNotificationDropdown.value) {
        showUserDropdown.value = false; // Close user dropdown if open
      }
    };

    const toggleUserDropdown = () => {
      showUserDropdown.value = !showUserDropdown.value;
      if (showUserDropdown.value) {
        showNotificationDropdown.value = false; // Close notification dropdown if open
      }
    };

    const logout = () => {
      userStore.logout();
      notificationStore.clearNotifications();
      router.push('/login');
    };

    return {
      user,
      isLoggedIn,
      unreadNotificationsCount,
      activeJobsCount,
      totalBadgeCount,
      showNotificationDropdown,
      showUserDropdown,
      toggleNotificationDropdown,
      toggleUserDropdown,
      logout,
    };
  },
};
</script>

<style scoped>
/* Basic styling for dropdown if needed, or rely on Bootstrap */
.dropdown-menu {
  display: none; /* Hidden by default */
}
.dropdown-menu.show {
  display: block; /* Shown when 'show' class is present */
}

/* s'assurer que le menu est bien ancré à droite du parent */
.dropdown { position: relative; }

.dropdown .dropdown-menu {
  left: auto;
  right: 0;
  transform-origin: right top;
  /* si le menu est trop large, il commencera à droite et se développera vers la gauche */
}

.notification-badge {
  font-size: 0.7em;
  vertical-align: top;
  margin-left: -5px;
}

.pfe-bell-spin {
  display: inline-block;
  animation: bell-spin 1s linear infinite;
}

@keyframes bell-spin {
  from { transform: rotate(0deg); }
  to   { transform: rotate(360deg); }
}

.notification-dropdown-menu {
  right: 0;
  left: auto;
  min-width: 400px;
  padding: 0px;
}
</style>